import React, { useCallback } from "react";
import Button from "@streeteasy/design-system/deprecated/Button";
import { Formik } from "formik";
import { any, shape, string } from "prop-types";

import { other as customOption } from "../../constants/formClaimValidation";
import { formClaimValidationSchema } from "../../schemas/formClaimValidation";
import {
  useStore,
  useValidationStoreData
} from "../../utilities/mobx/storeHooks";
import RadioInputGroup from "../RadioInputGroup";
import { RADIO_INPUT_GROUP_THEMES } from "../RadioInputGroup/radioInputGroupThemes";
import * as S from "./styled";

const HomeClaimValidationForm = ({
  ariaContentDescribedBy,
  ariaContentLabelledBy,
  className,
  initialFormErrors,
  initialFormValues
}) => {
  const { predefinedOptions } = useValidationStoreData();

  const { store } = useStore();
  const { validationStore } = store;

  const handleFormSubmit = useCallback((values, { setSubmitting }) => {
    validationStore.handleOwnerNameSubmit(values, {
      onError: () => setSubmitting(false)
    });
  }, []);

  return (
    <S.FormContent className={className}>
      <S.FormTitle id={ariaContentLabelledBy}>Proof of Ownership</S.FormTitle>
      <S.FormDescription id={ariaContentDescribedBy}>
        Please verify you are the homeowner. Select your name below and confirm
        your identity.
      </S.FormDescription>
      <Formik
        initialErrors={initialFormErrors}
        initialValues={initialFormValues}
        onSubmit={handleFormSubmit}
        validationSchema={formClaimValidationSchema}
      >
        {({ handleSubmit, isSubmitting, isValid, setFieldValue }) => (
          <form onSubmit={handleSubmit}>
            <RadioInputGroup
              customName="customOwnerName"
              customOptionLabel="Enter homeowner name"
              customOptionTrigger={customOption}
              name="predefinedOwnerName"
              onChange={(name, value) => setFieldValue(name, value, true)}
              options={[...predefinedOptions, customOption]}
              theme={RADIO_INPUT_GROUP_THEMES.button}
            />
            <Button
              disabled={isSubmitting || !isValid}
              theme="primary"
              type="submit"
            >
              I’m the homeowner
            </Button>
          </form>
        )}
      </Formik>
    </S.FormContent>
  );
};

HomeClaimValidationForm.defaultProps = {
  className: "",
  initialFormErrors: { predefinedOwnerName: "Required" },
  initialFormValues: {
    predefinedOwnerName: null,
    customOwnerName: null
  }
};

HomeClaimValidationForm.propTypes = {
  ariaContentDescribedBy: string.isRequired,
  ariaContentLabelledBy: string.isRequired,
  className: string,
  initialFormErrors: shape({
    predefinedOwnerName: any,
    customOwnerName: any
  }),
  initialFormValues: shape({
    predefinedOwnerName: string,
    customOwnerName: string
  })
};

export default HomeClaimValidationForm;
